export default {
  data() {
    return {
      activeCaste: this.$route.query.caste || null
    }
  },
  methods: {
    setActiveCaste(value) {
      this.activeCaste = value

      // update query params
      const query = Object.assign({}, this.$route.query);

      delete query.subcaste;
      delete query.caste;

      if (parseInt(value) > 0) {
        query.caste = value;
      }

      query.page = 1;

      if (this.$route.query !== query) {
        // to avoid duplicate navigation
        this.$router.push({ query: query });
      }
    }
  },
  watch: {
    activeCaste(newValue) {
      const query = Object.assign({}, this.$route.query, { caste: newValue });

      if (!newValue || newValue == "-1") {
        delete query.caste;
      }

      const sameNumOfParams = Object.keys(this.$route.query).length === Object.keys(query).length

      if (sameNumOfParams) {
        const sameParams = Object.keys(this.$route.query).every(key => this.$route.query[key] === query[key])
        if (!sameParams) {
          this.$router.push({ query: query })
        }
      } else {
        this.$router.push({ query: query })
      }
    }
  }
}
